import { z } from 'zod';

export const UserSchema = z.object({
  id: z.string(),
  name: z.string(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  email: z.string().email(),
  phone_number: z.string().optional().nullable(),
  role_id: z.string().optional(),
  permissions: z.array(z.string()),
  isAuthenticated: z.boolean().default(false),
  role: z.object({
    name: z.string(),
    id: z.string(),
    description: z.string(),
  }),
});

export type UserSchemaType = z.infer<typeof UserSchema>;
